module.exports = __webpack_public_path__ + "img/edge_restauration_confiserie.7e818821.svg";